module.exports = __webpack_public_path__ + "img/tongren_fenshu.f0f4cb97.png";